<footer class="main-footer">
  <div class="container-fluid px-0">
    <div class="footer-legal">
      <span class="footer-copyright">
        &copy; {{ currentYear }} {{ companyProfile?.title || 'GSTAT' }}. All rights reserved.
      </span>
      <span class="footer-version">
        <b>Version</b> 1.0.0
      </span>
    </div>
  </div>
</footer>